// Google Sheets Configuration
// Your Google Apps Script web app URL
export const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbyecFCDB1ZsZ9Snizwl4clV6aeLEGD5t49dJ2_3NjbdxH5oRzm4ZEd6L44O04WSQbLs/exec';

// Deployment Details:
// - Version 3 deployed on Aug 9, 2025, 12:54 AM
// - Deployment ID: AKfycbyecFCDB1ZsZ9Snizwl4clV6aeLEGD5t49dJ2_3NjbdxH5oRzm4ZEd6L44O04WSQbLs
// - Handles both email collection and contact form submissions
// - Supports dynamic tab organization via Settings tab in Google Sheets
